import React from 'react'

import { LoadMore } from '../details/collection'

import CommentItemContainer from '../../containers/comments/comment-item-container'
import CreateIssueCommentContainer from '../../containers/comments/create-issue-comment-container'

export default ({
  issue,
  comments,
  onLoadNextPage,
  hasNextPage
}) => (
  <div className='list'>
    <CreateIssueCommentContainer issueId={issue.id} />

    {comments.map(comment =>
      <CommentItemContainer key={comment.id} commentId={comment.id} unpinnable />
    )}

    <LoadMore onLoadNextPage={onLoadNextPage} hasNextPage={hasNextPage} />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/issues/issue-comments.js